import * as React from "react";
import { forwardRef } from "react";
const SvgSnsx = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 15, viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.612 1.95166H12.4003L8.47384 6.40738L13.0612 12.4517H9.46129L6.64278 8.7786L3.41608 12.4517H1.62779L5.78751 7.68598L1.39453 1.95166H5.08386L7.63023 5.30701L10.612 1.95166ZM9.98611 11.4055H10.9774L4.56292 2.95904H3.49772L9.98611 11.4055Z", fill: "current" }));
const ForwardRef = forwardRef(SvgSnsx);
export { ForwardRef as ReactComponent };
